<app-email-form [loggedInEmail]="loggedInEmail" [errors]="errors"></app-email-form>
